import { TreeNode } from "@/types/tree";
import { FutureLayerImageMeta, ImageControlAndInfo, ImageControlsAndInfoGroupedByNodeId, KeywordsForImageInNode, UpdateMode } from "./types";
import { documentStore } from "@/store/store";
import lodash from "lodash";
import { findNodeById } from "./util";

export function getImageControlsAndInfoGroupedByNodeId(keywordsForImages: KeywordsForImageInNode[]): ImageControlsAndInfoGroupedByNodeId {
  const groupedByNodeId = keywordsForImages.reduce((acc, item) => {
    if (!acc[item.nodeId]) {
      acc[item.nodeId] = [];
    }
    acc[item.nodeId].push({
      controlPath: item.controlPath,
      keywords: item.keywords,
      searchResults: [],
    });
    return acc;
  }, {} as Record<TreeNode['id'], ImageControlAndInfo[]>);

  return Object.entries(groupedByNodeId).map(([nodeId, data]) => ({
    nodeId: parseInt(nodeId),
    data
  }));
}

export function setImageControlsAndInfoOnNodes(groupedData: ImageControlsAndInfoGroupedByNodeId, mode: UpdateMode, section: TreeNode) {
  groupedData.forEach(({ nodeId, data }) => {
    setFutureLayerImageMetaOnNode(nodeId, data, mode, section);
  });
}

function setFutureLayerImageMetaOnNode(nodeId: TreeNode['id'], meta: FutureLayerImageMeta, mode: UpdateMode, section: TreeNode) {
  updateValueOnNode(
    nodeId,
    "meta.futureLayer.images",
    meta,
    `Updated futureLayer.images for node "${nodeId}"`,
    mode,
    section
  );
}

export function getFutureLayerImageMetaFromNode(node: TreeNode): FutureLayerImageMeta {
  return node.data.properties?.meta?.futureLayer?.images ?? [];
}

export function updateValueOnNode(
  nodeId: TreeNode["id"],
  path: string,
  value: any,
  snapshotLabel: string,
  mode: UpdateMode,
  section: TreeNode
) {
  if (mode === 'store') {
    documentStore.unthrottledPropertyChanged({
      elementId: nodeId,
      path,
      value,
      meta: { snapshotLabel }
    });
  } else {
    const targetNode = findNodeById(section, nodeId);
    if (targetNode) {
      lodash.set(targetNode, `data.properties.${path}`, value);
    }
  }
}
